import {MatDialog} from '@angular/material';

export const openDialog = (component: any, dataLoad: any, dialog: MatDialog, disabledClose: boolean = true, autoFocused: boolean = false) =>  {
    return dialog.open(component, {
        data: dataLoad, disableClose: disabledClose, autoFocus: autoFocused
    });
};
